import React, { useState, useRef } from "react";
import Canvas from "./components/Canvas";
import SideMenu from "./components/SideMenu";
import StartWindow  from "./components/StartWindow";
import "./App.css";

const App = () => {
  const [inputValues, setInputValues] = useState(["", "", "", ""]);
  // const [inputValues, setInputValues] = useState({matrixCoords: ["", "", "", ""]});
  const vectorCanvasRef = useRef(null);

  return (
    <div className="app">
      <StartWindow />
      <SideMenu inputValues={inputValues} setInputValues={setInputValues} vectorCanvasRef={vectorCanvasRef} />
      <Canvas vectorCanvasRef={vectorCanvasRef} setInputValues={setInputValues} />
    </div>
  );
};
 
export default App;
